module.exports = __webpack_public_path__ + "img/26.3020b139.jpg";